module.exports = __webpack_public_path__ + "img/checkmark-with-background.d06c8f89.svg";